// goods.js
const goods = {
    add_channel: 'Add channel',
    confirm_delete_channel: 'Are you sure you want to delete the [{channel_name}] channel?',
    add_goods: 'Add ticket',
    put_away: 'Put on the shelf',
    sold_out: 'Take off the shelf',
    please_select_object: 'Please select an object',
    edit_max_out_promotion: 'Edit full - reduction promotion',
    add_max_out_promotion: 'Add full - reduction promotion',
    promotion_name: 'Promotion activity name',
    please_fill_in_promotion_name: 'Please fill in the promotion activity name',
    please_select_time_range: 'Please select the start - end time range',
    in_progress: 'In progress',
    please_select_promotion_goods: 'Please select the promotional tickets',
    please_set_discount_price: 'Please set the discounted price for each ticket',
    channel_id: 'Channel ID',
    channel_name: 'Channel name',
    end_date: 'End date',
    channel_desc: 'Channel description',
    vip: 'Register as a VIP',
    is_used: 'Whether to enable',
    registration_identity: 'Registration identity',
    meeting_treatment: 'Conference treatment',
    collect_resume: 'Whether to collect resumes',
    is_collect: 'Collect',
    no_collect: 'Do not collect',
    related_ticket: 'Related tickets',
    related_ticket_extra: 'After associating tickets, only the associated tickets can be seen when entering the website through the channel link.',
    goods: 'Goods',
    title_login_top: 'Title at the top of the login box',
    login: 'User login',
    login_left_text: 'Explanatory text on the left side of the login page',
    collect_air: 'Whether to collect travel itineraries',
    update_ticket: 'Edit ticket',
    add_ticket: 'Add new ticket',
    ticket_info: 'Ticket information',
    ticket_name: 'Ticket name',
    ticket_num: 'Ticket number',
    ticket_type: 'Ticket type',
    ticket_type_1: 'Physical ticket',
    ticket_type_2: 'Virtual ticket',
    sotre_num: 'Inventory quantity',
    ticket_resume: 'Ticket introduction',
    edit_coupon: 'Edit coupon',
    add_coupon: 'Add coupon',
    coupon_name: 'Coupon name',
    merchant_coupon: 'Merchant coupon',
    ticket_coupon: 'Ticket coupon',
    full: 'Full',
    reduce: 'Reduce',
    yuan: 'Yuan',
    issue_quantity: 'Issuance quantity (sheets)',
    please_enter_issue_quantity: 'Please enter an integer between 1 and 1000',
    limit_per_person: 'Limit per person (sheets)',
    ticket_scope: 'Ticket scope',
    please_select_ticket_scope: 'Please select the ticket scope',
    all_tickets: 'All tickets',
    entry_ticket: 'Entry ticket',
    ordinary_member_entry_ticket: 'Ordinary member entry ticket',
    vip_member_entry_ticket: 'VIP member entry ticket',
    unit: 'Sheet',
    activity_name: 'Activity name',
    promotion_status: 'Promotion status',
    in_progress: 'In progress',
    paused: 'Paused',
    going: 'Issuing',
    wait_start: 'Not started',
    index: 'Serial number',
    price: 'Unit price',
    inventory: 'Inventory',
    discounted_price: 'Discounted price',
    unlimited: 'Unlimited',
    basic_config: 'Basic configuration',
    rule_name: 'Rule name',
    implementation_period: 'Implementation period',
    description_info: 'Description information',
    condition_info: 'Condition information',
    condition: 'Condition',
    please_select_object: 'Please select an object',
    please_select_logic_rule: 'Please select a logic rule',
    please_select_specific_parameters: 'Please select specific parameters',
    event_info: 'Event information',
    event: 'Event',
    prompt_text_information: 'Prompt text information',
    restrict_order_and_prompt_text_information: 'Restrict ordering and prompt text information',
    collect_audit_attachment_materials: 'Collect audit attachment materials',
    additional_content_collection_items: 'Additional content collection items',
    please_select_field_type: 'Please select the field type',
    single_line_text: 'Single - line text',
    upload_file: 'Upload file',
    please_select_maximum_number_of_files_to_upload: 'Please select the maximum number of files to upload',
    most_upload: 'Maximum upload',
    files: 'files',
    please_select_file_types_to_upload: 'Please select the file types to upload',
    please_select_form_collection_items: 'Please select the form collection items. Manage collection items by going to "User" - "Registration form configuration".',
    please_enter_prompt_content: 'Please enter the prompt content',
    add_condition: 'Add condition',
    add_event: 'Add event',
    step_1: 'Select main tickets',
    step_2: 'Matching settings',
    step_3: 'Discount settings',
    main_ticket: 'Main ticket',
    add_main_ticket: 'Add main ticket',
    vice_ticket: 'Vice - ticket',
    add_matching_ticket: 'Add matching ticket',
    please_enter_ticket_name: 'Please enter the ticket name',
    please_select_ticket_status: 'Please select the ticket status',
    ticket_status: 'Ticket status',
    on_shelf: 'On the shelf',
    off_shelf: 'Off the shelf',
    activity_info: 'Activity information',
    combination_name: 'Combination name',
    combination_description: 'Combination introduction',
    combination_type: 'Combination type',
    self_selection_combination: 'Self - selection combination',
    fixed_combination: 'Fixed combination',
    prompt: 'Prompt',
    prompt_1: 'Consumers can choose to buy the matching tickets in the package.',
    prompt_2: 'All tickets in the package are sold in a bundle, and consumers need to buy the whole package.',
    discount_info: 'Discount information',
    start_end_time: 'Start - end time',
    tickets_info: 'Ticket information',
    pieces: 'Pieces',
    yuan: 'Yuan',
    previous_step: 'Previous step',
    next_step: 'Next step',
    select: 'Select',
    status: 'Status',
    ticket_shuxing: 'Ticket attributes',
    original_price: 'Original price',
    dapei_num: 'Matching quantity',
    dapei_price: 'Matching price',
    edit_full_sales: 'Edit full - quantity promotion',
    add_full_sales: 'Add full - quantity promotion',
    discount_name: 'Discount name',
    ticket_label: 'Ticket',
    promotion_rules: 'Promotion rules',
    number: 'Number',
    pieces_discount: 'Pieces, get a',
    discount: 'Discount',
    dis_text: 'Discount',
    add_rules: 'Add rules',
    rules_1: 'Full - quantity calculation does not include historical orders, only the content of the submitted order is calculated.',
    please_fill_in_spend: 'Please fill in the full amount',
    please_fill_in_discount: 'Please fill in the discount amount',
    add_jieti: 'Add tier',
    error_1: 'The discount amount must be less than the full amount!',
    order_detail: 'Order details',
    basic_info: 'Basic information',
    order_no: 'Order number',
    user_account: 'User account',
    pay_method: 'Payment method',
    payable_price: 'Payable price',
    shi_price: 'Actual paid price',
    pay_time: 'Payment time',
    pay_status: 'Payment status',
    ticket_holder: 'Ticket holder',
    payer: 'Payer',
    cashier_order_no: 'Cashier order number',
    audit_materials: 'Audit materials',
    audit_status: 'Audit status',
    audit_remark: 'Audit remark',
    confirm_audit: 'Confirm audit',
    invoice_info: 'Invoice information',
    invoice_record: 'Invoice record',
    invoice_type: 'Invoice type',
    invoice_title: 'Invoice title',
    tax_number: 'Tax number',
    invoice_content: 'Invoice content',
    no_invoice: 'No invoice needed',
    cost_info: 'Cost information',
    total_amount: 'Total amount',
    discount_amount: 'Discount amount',
    amount_to_pay: 'Amount to pay',
    actual_amount_paid: 'Actual amount paid',
    un_payment: 'Unpaid',
    payment_info: 'Payment information',
    view_receipt: 'View',
    confirm_modify: 'Confirm modification',
    upload_failed: 'You can only upload doc, docx formats and images',
    file_size_limit: 'File size cannot exceed 3M',
    upload_voucher: 'Remittance voucher',
    upload: 'Upload',
    viewing_files: 'View files',
    no_files: 'No files',
    temp_no: 'Temporarily no',
    back_money_ing: 'Refunding',
    backed_money: 'Refunded',
    half_money: 'Partially refunded',
    has_pay: 'Paid',
    pass: 'Pass',
    no_pass: 'Rejected',
    order_remark: 'Order remark',
    download: 'Download',
    wait_pay: 'Waiting for payment',
    upload_voucher_tips: 'Please upload the remittance voucher',
    file_name: 'File name',
    submit_time: 'Submission time',
    type: 'Type',
    file: 'File',
    details: 'Details',
    small_total: 'Sub - total',
    invoice_1: 'VAT ordinary invoice',
    invoice_2: 'VAT special invoice',
    invoice_3: 'VAT ordinary electronic invoice',
    invoice_4: 'Fixed - amount invoice',
    invoice_title_1: 'Individual',
    invoice_title_2: 'Enterprise - type unit',
    invoice_title_3: 'Non - enterprise - type unit',
    file_link: 'File link',
    invoice_details: 'Invoice details',
    need_text: 'Need',
    no_need_text: 'No need',
    tax_number_1: 'Units with tax numbers such as hospitals, scientific research institutes, and universities',
    tax_number_2: 'Government/Army units without tax numbers',
    tax_number_3: 'Individual',
    organization: 'Unit',
    taxer_no: 'Taxpayer identification number',
    receive_email: 'Invoice recipient email',
    invoice_address: 'Business license registration address',
    tel: 'Registered landline number',
    bank: 'Bank of deposit',
    base_account_no: 'Basic bank account number',
    receive_name: 'Invoice recipient name',
    receive_mobile: 'Invoice recipient mobile phone number',
    receive_address: 'Invoice recipient address',
    no_set_invoice: 'Invoice not configured',
    refund_reason: 'Refund reason',
    refund_amount: 'Refund amount',
    refund_way: 'Refund method',
    refund_from: 'Refund channel',
    refund_way_1: 'Refund the original way',
    refund_way_2: 'Reject refund',
    refund_way_3: 'Manual refund',
    account_bank: 'Bank of deposit',
    account_no: 'Bank account number',
    account_name: 'Account holder name',
    account_mobiel: 'Account holder mobile phone number',
    account_company: 'Account holder unit',
    refund_remark: 'Refund remark',
    refund_success: 'Refund successful',
    is_show: 'Whether to show on the cashier desk',
    is_show_extra: 'If you choose to hide this payment method, it will only be shown in the conference background, which means this payment method will not be shown during front - end payment.',
    other_name: 'Alias',
    pay_info: 'Payment description',
    edit_jieti_sales: 'Edit tiered promotion',
    add_jieti_sales: 'Add tiered promotion',
    promotion_activity_set: 'Promotion activity settings',
    select_promotion_ticket: 'Select promotional tickets',
    ticket_discount_set: 'Ticket discount settings',
    enter_discount_price: 'Please fill in the discounted price',
    select_ticket: 'Select ticket',
    message: 'Coupons: Preferential vouchers applicable to various scenarios.',
    enter_name_no: 'Please enter the ticket name/number',
    single_add: 'Add',
    message_1: 'Time - limited promotion: Set ticket prices by time period.',
    start_time: 'Start time',
    end_time: 'End time',
    delete_confirm_ticket: 'Are you sure you want to delete this ticket?',
    faxing_status: 'Issuing status',
    valid_start_time: 'Validity start time',
    valid_end_time: 'Validity end time',
    message_2: 'Matching promotion: Multiple tickets are promoted together.',
    message_3: 'Full - quantity promotion: Get a discount when reaching a certain quantity.',
    message_4: 'Full - amount promotion: Get a reduction when reaching a certain amount.',
    channel_link: 'Channel link',
    confirm_delete_channel: 'Are you sure you want to delete the [{value}] channel?',
    add_goods_type: 'Add category',
    enter_sort: 'Please enter the sorting',
    add_child_type: 'Add child category',
    goods_type: 'Category',
    ticket_type_name: 'Ticket type name',
    is_del_ticket: 'Whether to delete this ticket?',
    marketing_rules: 'Purchase restriction rules: Restrictions on the purchase eligibility or quantity of specified tickets for certain customers in certain scenarios.',
    doing_status: 'Implementation status',
    audit: 'Audit',
    refund: 'Refund',
    goods_info: 'Goods information',
    order_money: 'Order amount',
    del_order: 'Are you sure you want to delete this order?',
    pay_inline: 'Online payment',
    pay_outline: 'Offline payment',
    pay_name: 'Payment name',
    show_refund_button: 'Whether to show the refund button',
    collect_refund_account: 'Whether to collect refund account information',
    refund_end_time: 'Refund deadline',
    sale_count: 'Sales quantity',
    sale_money: 'Sales amount',
    total: 'Total',
    order_detail: 'Order details',
    submit_order: 'Submit order',
    audit_rejected: 'Audit failed',
    audit_passed: 'Audit passed',
    payment_completed: 'Payment completed',
    completed: 'Completed',
    no_invoice: 'No invoice needed',
    category: {
        new: 'New Category',
        edit: 'Edit Category',
        parent_category: 'Please enter the parent category',
        enter_category_name: 'Please enter the category name',
        child_type_limit: 'Please enter the child type limit',
        select_category: 'Please enter the options that can be selected within this category',
        ticket_count_limit: 'Please enter the ticket quantity limit',
        sort: 'Please enter the sorting',
        description_text: 'Please enter the description text'
    },
    order_list: {
        mobile: 'Please enter the mobile phone number',
        user_name: 'Please enter the user name',
        order_no: 'Please enter the order number',
        pay_way: 'Please select the payment method',
        pay_status: 'Please select the payment status',
        audit_status: 'Please select the audit status',
        refund_status: 'Please select the refund status',
        goods_type: 'Please select the ticket category',
        goods_name: 'Please select the ticket name'
    },
    invoice_list: {
        search_name: 'Name/Company/Mobile/Registration No.',
        key_type: 'Keyword Type',
        key_type_name: 'Name',
        key_type_reg_no: 'Registration No.',
        key_type_mobile: 'Mobile',
        key_type_company: 'Company',
        key_type_email: 'Email',
        key_type_pinyin: 'Pinyin',
        pay_way: 'Please select payment method',
        invoice_type: 'Invoice Type',
        invoice_type_normal: 'VAT Ordinary Paper Invoice',
        invoice_type_special: 'VAT Special Invoice',
        invoice_type_electronic: 'VAT Ordinary Electronic Invoice',
        invoice_type_fixed: 'Fixed Amount Invoice',
        inv_title: 'Invoice Title Type',
        inv_title_personal: 'Personal',
        inv_title_organization: 'Hospital/Research Institute/University with Tax ID',
        inv_title_government: 'Government/Military without Tax ID',
        open_status: 'Invoice Status',
        open_status_no: 'Not Issued',
        open_status_yes: 'Issued',
        open_status_loading : 'Invoicing in progress',
        is_reg: 'Check-in Status',
        is_reg_no: 'Not Checked-in',
        is_reg_yes: 'Checked-in',
        red_status: 'Refund Status',
        red_status_no: 'Not Applied',
        red_status_yes: 'Red-flushed',
        description: 'Invoice Remarks',
        org_calss: 'Other Filter Conditions',
        org_calss_inconsistent: 'User company and title inconsistent',
        org_calss_tax_short: 'Tax ID less than 18 digits',
        email_sms: 'Email/SMS Send Status',
        email_sms_no_email: 'Email not sent',
        email_sms_no_sms: 'SMS not sent',
        sort: 'Sort',
        sort_tax_asc: 'Tax ID ascending',
        sort_time_desc: 'Invoice request time descending',
        individual: "Individual",
        unit_name: "Company Name",
        needs_review: "Needs Review",
        not_registered: "Not Registered",
        no_payment: "No Payment",
        paid: "Paid",
        unpaid: "Unpaid",
        invoice_title: "Invoice Title/Tax ID",
        mobile_email: "Mobile/Email",
        expense_type: "Expense Type",
        regispay: "Payment Status",
        payment_time: "Payment Time",
        invoice_request_time: "Invoice Request Time",
        amount: "Amount",
        del_invoice: 'Are you sure you want to delete this invoice?',
    },
    order_invoice_edit: {
        invoice_title: 'Please select the invoice title',
        invoice_content: 'Please select the invoice content',
        organization: 'Please enter the entity name',
        taxer_no: 'Please enter the taxpayer identification number',
        receive_email: 'Please enter the email address of the invoice recipient',
        invoice_address: 'Please enter the registered address on the business license',
        tel: 'Please enter the registered landline number',
        bank: 'Please enter the name of the bank of deposit',
        base_account_no: 'Please enter the basic account number',
        receive_name: 'Please enter the name of the invoice recipient',
        receive_mobile: 'Please enter the mobile number of the invoice recipient',
        receive_address: 'Please enter the address of the invoice recipient',
        remark: 'Please enter the remarks',
        audit_remark: 'Please enter the audit remarks'
    },
    other_config: 'Other Configurations'
};

export default goods;
